// Country data with dial codes, flags, and phone number formats
export interface Country {
  code: string; // ISO 2-letter country code
  name: string;
  dialCode: string;
  flag: string; // Unicode flag emoji
  format: string; // Phone number format pattern
  minLength: number;
  maxLength: number;
}

export const countries: Country[] = [
  {
    code: 'AD',
    name: 'Andorra',
    dialCode: '+376',
    flag: '🇦🇩',
    format: 'XXX XXX',
    minLength: 6,
    maxLength: 6,
  },
  {
    code: 'AE',
    name: 'United Arab Emirates',
    dialCode: '+971',
    flag: '🇦🇪',
    format: 'XX XXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'AF',
    name: 'Afghanistan',
    dialCode: '+93',
    flag: '🇦🇫',
    format: 'XX XXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'AG',
    name: 'Antigua and Barbuda',
    dialCode: '+1268',
    flag: '🇦🇬',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'AI',
    name: 'Anguilla',
    dialCode: '+1264',
    flag: '🇦🇮',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'AL',
    name: 'Albania',
    dialCode: '+355',
    flag: '🇦🇱',
    format: 'XX XXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'AM',
    name: 'Armenia',
    dialCode: '+374',
    flag: '🇦🇲',
    format: 'XX XXX XXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'AO',
    name: 'Angola',
    dialCode: '+244',
    flag: '🇦🇴',
    format: 'XXX XXX XXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'AR',
    name: 'Argentina',
    dialCode: '+54',
    flag: '🇦🇷',
    format: 'XX XXXX XXXX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'AS',
    name: 'American Samoa',
    dialCode: '+1684',
    flag: '🇦🇸',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'AT',
    name: 'Austria',
    dialCode: '+43',
    flag: '🇦🇹',
    format: 'XXX XXX XXXX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'AU',
    name: 'Australia',
    dialCode: '+61',
    flag: '🇦🇺',
    format: 'XXX XXX XXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'AW',
    name: 'Aruba',
    dialCode: '+297',
    flag: '🇦🇼',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'AZ',
    name: 'Azerbaijan',
    dialCode: '+994',
    flag: '🇦🇿',
    format: 'XX XXX XX XX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'BA',
    name: 'Bosnia and Herzegovina',
    dialCode: '+387',
    flag: '🇧🇦',
    format: 'XX XXX XXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'BB',
    name: 'Barbados',
    dialCode: '+1246',
    flag: '🇧🇧',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'BD',
    name: 'Bangladesh',
    dialCode: '+880',
    flag: '🇧🇩',
    format: 'XXXX XXXXXX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'BE',
    name: 'Belgium',
    dialCode: '+32',
    flag: '🇧🇪',
    format: 'XXX XX XX XX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'BF',
    name: 'Burkina Faso',
    dialCode: '+226',
    flag: '🇧🇫',
    format: 'XX XX XX XX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'BG',
    name: 'Bulgaria',
    dialCode: '+359',
    flag: '🇧🇬',
    format: 'XX XXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'BH',
    name: 'Bahrain',
    dialCode: '+973',
    flag: '🇧🇭',
    format: 'XXXX XXXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'BI',
    name: 'Burundi',
    dialCode: '+257',
    flag: '🇧🇮',
    format: 'XX XX XX XX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'BJ',
    name: 'Benin',
    dialCode: '+229',
    flag: '🇧🇯',
    format: 'XX XX XX XX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'BM',
    name: 'Bermuda',
    dialCode: '+1441',
    flag: '🇧🇲',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'BN',
    name: 'Brunei',
    dialCode: '+673',
    flag: '🇧🇳',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'BO',
    name: 'Bolivia',
    dialCode: '+591',
    flag: '🇧🇴',
    format: 'X XXX XXXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'BR',
    name: 'Brazil',
    dialCode: '+55',
    flag: '🇧🇷',
    format: 'XX XXXXX XXXX',
    minLength: 11,
    maxLength: 11,
  },
  {
    code: 'BS',
    name: 'Bahamas',
    dialCode: '+1242',
    flag: '🇧🇸',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'BT',
    name: 'Bhutan',
    dialCode: '+975',
    flag: '🇧🇹',
    format: 'XX XXX XXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'BW',
    name: 'Botswana',
    dialCode: '+267',
    flag: '🇧🇼',
    format: 'XX XXX XXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'BY',
    name: 'Belarus',
    dialCode: '+375',
    flag: '🇧🇾',
    format: 'XX XXX XX XX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'BZ',
    name: 'Belize',
    dialCode: '+501',
    flag: '🇧🇿',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'CA',
    name: 'Canada',
    dialCode: '+1',
    flag: '🇨🇦',
    format: 'XXX XXX XXXX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'CD',
    name: 'Democratic Republic of the Congo',
    dialCode: '+243',
    flag: '🇨🇩',
    format: 'XXX XXX XXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'CF',
    name: 'Central African Republic',
    dialCode: '+236',
    flag: '🇨🇫',
    format: 'XX XX XX XX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'CG',
    name: 'Republic of the Congo',
    dialCode: '+242',
    flag: '🇨🇬',
    format: 'XX XXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'CH',
    name: 'Switzerland',
    dialCode: '+41',
    flag: '🇨🇭',
    format: 'XX XXX XX XX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'CI',
    name: 'Ivory Coast',
    dialCode: '+225',
    flag: '🇨🇮',
    format: 'XX XX XX XX XX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'CK',
    name: 'Cook Islands',
    dialCode: '+682',
    flag: '🇨🇰',
    format: 'XX XXX',
    minLength: 5,
    maxLength: 5,
  },
  {
    code: 'CL',
    name: 'Chile',
    dialCode: '+56',
    flag: '🇨🇱',
    format: 'X XXXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'CM',
    name: 'Cameroon',
    dialCode: '+237',
    flag: '🇨🇲',
    format: 'XXXX XXXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'CN',
    name: 'China',
    dialCode: '+86',
    flag: '🇨🇳',
    format: 'XXX XXXX XXXX',
    minLength: 11,
    maxLength: 11,
  },
  {
    code: 'CO',
    name: 'Colombia',
    dialCode: '+57',
    flag: '🇨🇴',
    format: 'XXX XXX XXXX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'CR',
    name: 'Costa Rica',
    dialCode: '+506',
    flag: '🇨🇷',
    format: 'XXXX XXXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'CU',
    name: 'Cuba',
    dialCode: '+53',
    flag: '🇨🇺',
    format: 'X XXX XXXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'CV',
    name: 'Cape Verde',
    dialCode: '+238',
    flag: '🇨🇻',
    format: 'XXX XX XX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'CW',
    name: 'Curaçao',
    dialCode: '+599',
    flag: '🇨🇼',
    format: 'X XXX XXXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'CY',
    name: 'Cyprus',
    dialCode: '+357',
    flag: '🇨🇾',
    format: 'XX XXX XXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'CZ',
    name: 'Czech Republic',
    dialCode: '+420',
    flag: '🇨🇿',
    format: 'XXX XXX XXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'DE',
    name: 'Germany',
    dialCode: '+49',
    flag: '🇩🇪',
    format: 'XXX XXXXXXX',
    minLength: 10,
    maxLength: 11,
  },
  {
    code: 'DJ',
    name: 'Djibouti',
    dialCode: '+253',
    flag: '🇩🇯',
    format: 'XX XX XX XX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'DK',
    name: 'Denmark',
    dialCode: '+45',
    flag: '🇩🇰',
    format: 'XX XX XX XX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'DM',
    name: 'Dominica',
    dialCode: '+1767',
    flag: '🇩🇲',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'DO',
    name: 'Dominican Republic',
    dialCode: '+1',
    flag: '🇩🇴',
    format: 'XXX XXX XXXX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'DZ',
    name: 'Algeria',
    dialCode: '+213',
    flag: '🇩🇿',
    format: 'XXX XX XX XX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'EC',
    name: 'Ecuador',
    dialCode: '+593',
    flag: '🇪🇨',
    format: 'XX XXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'EE',
    name: 'Estonia',
    dialCode: '+372',
    flag: '🇪🇪',
    format: 'XXXX XXXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'EG',
    name: 'Egypt',
    dialCode: '+20',
    flag: '🇪🇬',
    format: 'XX XXXX XXXX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'ER',
    name: 'Eritrea',
    dialCode: '+291',
    flag: '🇪🇷',
    format: 'X XXX XXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'ES',
    name: 'Spain',
    dialCode: '+34',
    flag: '🇪🇸',
    format: 'XXX XXX XXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'ET',
    name: 'Ethiopia',
    dialCode: '+251',
    flag: '🇪🇹',
    format: 'XX XXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'FI',
    name: 'Finland',
    dialCode: '+358',
    flag: '🇫🇮',
    format: 'XX XXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'FJ',
    name: 'Fiji',
    dialCode: '+679',
    flag: '🇫🇯',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'FK',
    name: 'Falkland Islands',
    dialCode: '+500',
    flag: '🇫🇰',
    format: 'XXXXX',
    minLength: 5,
    maxLength: 5,
  },
  {
    code: 'FM',
    name: 'Micronesia',
    dialCode: '+691',
    flag: '🇫🇲',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'FO',
    name: 'Faroe Islands',
    dialCode: '+298',
    flag: '🇫🇴',
    format: 'XXX XXX',
    minLength: 6,
    maxLength: 6,
  },
  {
    code: 'FR',
    name: 'France',
    dialCode: '+33',
    flag: '🇫🇷',
    format: 'X XX XX XX XX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'GA',
    name: 'Gabon',
    dialCode: '+241',
    flag: '🇬🇦',
    format: 'X XX XX XX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'GB',
    name: 'United Kingdom',
    dialCode: '+44',
    flag: '🇬🇧',
    format: 'XXXX XXX XXXX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'GD',
    name: 'Grenada',
    dialCode: '+1473',
    flag: '🇬🇩',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'GE',
    name: 'Georgia',
    dialCode: '+995',
    flag: '🇬🇪',
    format: 'XXX XXX XXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'GF',
    name: 'French Guiana',
    dialCode: '+594',
    flag: '🇬🇫',
    format: 'XXX XX XX XX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'GG',
    name: 'Guernsey',
    dialCode: '+44',
    flag: '🇬🇬',
    format: 'XXXX XXX XXXX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'GH',
    name: 'Ghana',
    dialCode: '+233',
    flag: '🇬🇭',
    format: 'XX XXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'GI',
    name: 'Gibraltar',
    dialCode: '+350',
    flag: '🇬🇮',
    format: 'XXXX XXXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'GL',
    name: 'Greenland',
    dialCode: '+299',
    flag: '🇬🇱',
    format: 'XX XX XX',
    minLength: 6,
    maxLength: 6,
  },
  {
    code: 'GM',
    name: 'Gambia',
    dialCode: '+220',
    flag: '🇬🇲',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'GN',
    name: 'Guinea',
    dialCode: '+224',
    flag: '🇬🇳',
    format: 'XXX XXX XXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'GP',
    name: 'Guadeloupe',
    dialCode: '+590',
    flag: '🇬🇵',
    format: 'XXX XX XX XX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'GQ',
    name: 'Equatorial Guinea',
    dialCode: '+240',
    flag: '🇬🇶',
    format: 'XXX XXX XXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'GR',
    name: 'Greece',
    dialCode: '+30',
    flag: '🇬🇷',
    format: 'XXX XXX XXXX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'GT',
    name: 'Guatemala',
    dialCode: '+502',
    flag: '🇬🇹',
    format: 'XXXX XXXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'GU',
    name: 'Guam',
    dialCode: '+1671',
    flag: '🇬🇺',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'GW',
    name: 'Guinea-Bissau',
    dialCode: '+245',
    flag: '🇬🇼',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'GY',
    name: 'Guyana',
    dialCode: '+592',
    flag: '🇬🇾',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'HK',
    name: 'Hong Kong',
    dialCode: '+852',
    flag: '🇭🇰',
    format: 'XXXX XXXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'HN',
    name: 'Honduras',
    dialCode: '+504',
    flag: '🇭🇳',
    format: 'XXXX XXXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'HR',
    name: 'Croatia',
    dialCode: '+385',
    flag: '🇭🇷',
    format: 'XX XXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'HT',
    name: 'Haiti',
    dialCode: '+509',
    flag: '🇭🇹',
    format: 'XX XX XXXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'HU',
    name: 'Hungary',
    dialCode: '+36',
    flag: '🇭🇺',
    format: 'XX XXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'ID',
    name: 'Indonesia',
    dialCode: '+62',
    flag: '🇮🇩',
    format: 'XXX XXXX XXXX',
    minLength: 10,
    maxLength: 11,
  },
  {
    code: 'IE',
    name: 'Ireland',
    dialCode: '+353',
    flag: '🇮🇪',
    format: 'XX XXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'IL',
    name: 'Israel',
    dialCode: '+972',
    flag: '🇮🇱',
    format: 'XX XXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'IM',
    name: 'Isle of Man',
    dialCode: '+44',
    flag: '🇮🇲',
    format: 'XXXX XXX XXXX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'IN',
    name: 'India',
    dialCode: '+91',
    flag: '🇮🇳',
    format: 'XXXXX XXXXX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'IO',
    name: 'British Indian Ocean Territory',
    dialCode: '+246',
    flag: '🇮🇴',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'IQ',
    name: 'Iraq',
    dialCode: '+964',
    flag: '🇮🇶',
    format: 'XXX XXX XXXX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'IR',
    name: 'Iran',
    dialCode: '+98',
    flag: '🇮🇷',
    format: 'XXX XXX XXXX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'IS',
    name: 'Iceland',
    dialCode: '+354',
    flag: '🇮🇸',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'IT',
    name: 'Italy',
    dialCode: '+39',
    flag: '🇮🇹',
    format: 'XXX XXX XXXX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'JE',
    name: 'Jersey',
    dialCode: '+44',
    flag: '🇯🇪',
    format: 'XXXX XXX XXXX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'JM',
    name: 'Jamaica',
    dialCode: '+1876',
    flag: '🇯🇲',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'JO',
    name: 'Jordan',
    dialCode: '+962',
    flag: '🇯🇴',
    format: 'X XXXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'JP',
    name: 'Japan',
    dialCode: '+81',
    flag: '🇯🇵',
    format: 'XX XXXX XXXX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'KE',
    name: 'Kenya',
    dialCode: '+254',
    flag: '🇰🇪',
    format: 'XXX XXXXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'KG',
    name: 'Kyrgyzstan',
    dialCode: '+996',
    flag: '🇰🇬',
    format: 'XXX XXX XXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'KH',
    name: 'Cambodia',
    dialCode: '+855',
    flag: '🇰🇭',
    format: 'XX XXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'KI',
    name: 'Kiribati',
    dialCode: '+686',
    flag: '🇰🇮',
    format: 'XX XXX',
    minLength: 5,
    maxLength: 5,
  },
  {
    code: 'KM',
    name: 'Comoros',
    dialCode: '+269',
    flag: '🇰🇲',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'KN',
    name: 'Saint Kitts and Nevis',
    dialCode: '+1869',
    flag: '🇰🇳',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'KP',
    name: 'North Korea',
    dialCode: '+850',
    flag: '🇰🇵',
    format: 'XXX XXX XXXX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'KR',
    name: 'South Korea',
    dialCode: '+82',
    flag: '🇰🇷',
    format: 'XX XXXX XXXX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'KW',
    name: 'Kuwait',
    dialCode: '+965',
    flag: '🇰🇼',
    format: 'XXXX XXXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'KY',
    name: 'Cayman Islands',
    dialCode: '+1345',
    flag: '🇰🇾',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'KZ',
    name: 'Kazakhstan',
    dialCode: '+7',
    flag: '🇰🇿',
    format: 'XXX XXX XX XX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'LA',
    name: 'Laos',
    dialCode: '+856',
    flag: '🇱🇦',
    format: 'XX XXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'LB',
    name: 'Lebanon',
    dialCode: '+961',
    flag: '🇱🇧',
    format: 'XX XXX XXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'LC',
    name: 'Saint Lucia',
    dialCode: '+1758',
    flag: '🇱🇨',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'LI',
    name: 'Liechtenstein',
    dialCode: '+423',
    flag: '🇱🇮',
    format: 'XXX XX XX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'LK',
    name: 'Sri Lanka',
    dialCode: '+94',
    flag: '🇱🇰',
    format: 'XX XXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'LR',
    name: 'Liberia',
    dialCode: '+231',
    flag: '🇱🇷',
    format: 'XX XXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'LS',
    name: 'Lesotho',
    dialCode: '+266',
    flag: '🇱🇸',
    format: 'XXXX XXXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'LT',
    name: 'Lithuania',
    dialCode: '+370',
    flag: '🇱🇹',
    format: 'XXX XXXXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'LU',
    name: 'Luxembourg',
    dialCode: '+352',
    flag: '🇱🇺',
    format: 'XXX XXX XXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'LV',
    name: 'Latvia',
    dialCode: '+371',
    flag: '🇱🇻',
    format: 'XX XXX XXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'LY',
    name: 'Libya',
    dialCode: '+218',
    flag: '🇱🇾',
    format: 'XX XXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'MA',
    name: 'Morocco',
    dialCode: '+212',
    flag: '🇲🇦',
    format: 'XXX XXX XXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'MC',
    name: 'Monaco',
    dialCode: '+377',
    flag: '🇲🇨',
    format: 'XX XX XX XX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'MD',
    name: 'Moldova',
    dialCode: '+373',
    flag: '🇲🇩',
    format: 'XXXX XXXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'ME',
    name: 'Montenegro',
    dialCode: '+382',
    flag: '🇲🇪',
    format: 'XX XXX XXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'MF',
    name: 'Saint Martin',
    dialCode: '+590',
    flag: '🇲🇫',
    format: 'XXX XX XX XX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'MG',
    name: 'Madagascar',
    dialCode: '+261',
    flag: '🇲🇬',
    format: 'XX XX XXX XX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'MH',
    name: 'Marshall Islands',
    dialCode: '+692',
    flag: '🇲🇭',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'MK',
    name: 'North Macedonia',
    dialCode: '+389',
    flag: '🇲🇰',
    format: 'XX XXX XXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'ML',
    name: 'Mali',
    dialCode: '+223',
    flag: '🇲🇱',
    format: 'XX XX XX XX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'MM',
    name: 'Myanmar',
    dialCode: '+95',
    flag: '🇲🇲',
    format: 'XX XXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'MN',
    name: 'Mongolia',
    dialCode: '+976',
    flag: '🇲🇳',
    format: 'XXXX XXXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'MO',
    name: 'Macau',
    dialCode: '+853',
    flag: '🇲🇴',
    format: 'XXXX XXXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'MP',
    name: 'Northern Mariana Islands',
    dialCode: '+1670',
    flag: '🇲🇵',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'MQ',
    name: 'Martinique',
    dialCode: '+596',
    flag: '🇲🇶',
    format: 'XXX XX XX XX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'MR',
    name: 'Mauritania',
    dialCode: '+222',
    flag: '🇲🇷',
    format: 'XX XX XX XX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'MS',
    name: 'Montserrat',
    dialCode: '+1664',
    flag: '🇲🇸',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'MT',
    name: 'Malta',
    dialCode: '+356',
    flag: '🇲🇹',
    format: 'XXXX XXXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'MU',
    name: 'Mauritius',
    dialCode: '+230',
    flag: '🇲🇺',
    format: 'XXXX XXXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'MV',
    name: 'Maldives',
    dialCode: '+960',
    flag: '🇲🇻',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'MW',
    name: 'Malawi',
    dialCode: '+265',
    flag: '🇲🇼',
    format: 'XX XXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'MX',
    name: 'Mexico',
    dialCode: '+52',
    flag: '🇲🇽',
    format: 'XXX XXX XXXX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'MY',
    name: 'Malaysia',
    dialCode: '+60',
    flag: '🇲🇾',
    format: 'XX XXXX XXXX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'MZ',
    name: 'Mozambique',
    dialCode: '+258',
    flag: '🇲🇿',
    format: 'XX XXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'NA',
    name: 'Namibia',
    dialCode: '+264',
    flag: '🇳🇦',
    format: 'XX XXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'NC',
    name: 'New Caledonia',
    dialCode: '+687',
    flag: '🇳🇨',
    format: 'XX XX XX',
    minLength: 6,
    maxLength: 6,
  },
  {
    code: 'NE',
    name: 'Niger',
    dialCode: '+227',
    flag: '🇳🇪',
    format: 'XX XX XX XX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'NF',
    name: 'Norfolk Island',
    dialCode: '+672',
    flag: '🇳🇫',
    format: 'XXX XXX',
    minLength: 6,
    maxLength: 6,
  },
  {
    code: 'NG',
    name: 'Nigeria',
    dialCode: '+234',
    flag: '🇳🇬',
    format: 'XXX XXX XXXX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'NI',
    name: 'Nicaragua',
    dialCode: '+505',
    flag: '🇳🇮',
    format: 'XXXX XXXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'NL',
    name: 'Netherlands',
    dialCode: '+31',
    flag: '🇳🇱',
    format: 'XX XXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'NO',
    name: 'Norway',
    dialCode: '+47',
    flag: '🇳🇴',
    format: 'XXX XX XXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'NP',
    name: 'Nepal',
    dialCode: '+977',
    flag: '🇳🇵',
    format: 'XXX XXX XXXX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'NR',
    name: 'Nauru',
    dialCode: '+674',
    flag: '🇳🇷',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'NU',
    name: 'Niue',
    dialCode: '+683',
    flag: '🇳🇺',
    format: 'XXXX',
    minLength: 4,
    maxLength: 4,
  },
  {
    code: 'NZ',
    name: 'New Zealand',
    dialCode: '+64',
    flag: '🇳🇿',
    format: 'XX XXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'OM',
    name: 'Oman',
    dialCode: '+968',
    flag: '🇴🇲',
    format: 'XXXX XXXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'PA',
    name: 'Panama',
    dialCode: '+507',
    flag: '🇵🇦',
    format: 'XXXX XXXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'PE',
    name: 'Peru',
    dialCode: '+51',
    flag: '🇵🇪',
    format: 'XXX XXX XXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'PF',
    name: 'French Polynesia',
    dialCode: '+689',
    flag: '🇵🇫',
    format: 'XX XX XX XX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'PG',
    name: 'Papua New Guinea',
    dialCode: '+675',
    flag: '🇵🇬',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'PH',
    name: 'Philippines',
    dialCode: '+63',
    flag: '🇵🇭',
    format: 'XXX XXX XXXX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'PK',
    name: 'Pakistan',
    dialCode: '+92',
    flag: '🇵🇰',
    format: 'XXX XXX XXXX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'PL',
    name: 'Poland',
    dialCode: '+48',
    flag: '🇵🇱',
    format: 'XXX XXX XXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'PM',
    name: 'Saint Pierre and Miquelon',
    dialCode: '+508',
    flag: '🇵🇲',
    format: 'XX XX XX',
    minLength: 6,
    maxLength: 6,
  },
  {
    code: 'PN',
    name: 'Pitcairn Islands',
    dialCode: '+64',
    flag: '🇵🇳',
    format: 'XX XXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'PR',
    name: 'Puerto Rico',
    dialCode: '+1',
    flag: '🇵🇷',
    format: 'XXX XXX XXXX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'PS',
    name: 'Palestine',
    dialCode: '+970',
    flag: '🇵🇸',
    format: 'XXX XXX XXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'PT',
    name: 'Portugal',
    dialCode: '+351',
    flag: '🇵🇹',
    format: 'XXX XXX XXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'PW',
    name: 'Palau',
    dialCode: '+680',
    flag: '🇵🇼',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'PY',
    name: 'Paraguay',
    dialCode: '+595',
    flag: '🇵🇾',
    format: 'XXX XXX XXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'QA',
    name: 'Qatar',
    dialCode: '+974',
    flag: '🇶🇦',
    format: 'XXXX XXXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'RE',
    name: 'Réunion',
    dialCode: '+262',
    flag: '🇷🇪',
    format: 'XXX XX XX XX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'RO',
    name: 'Romania',
    dialCode: '+40',
    flag: '🇷🇴',
    format: 'XXX XXX XXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'RS',
    name: 'Serbia',
    dialCode: '+381',
    flag: '🇷🇸',
    format: 'XX XXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'RU',
    name: 'Russia',
    dialCode: '+7',
    flag: '🇷🇺',
    format: 'XXX XXX XX XX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'RW',
    name: 'Rwanda',
    dialCode: '+250',
    flag: '🇷🇼',
    format: 'XXX XXX XXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'SA',
    name: 'Saudi Arabia',
    dialCode: '+966',
    flag: '🇸🇦',
    format: 'XX XXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'SB',
    name: 'Solomon Islands',
    dialCode: '+677',
    flag: '🇸🇧',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'SC',
    name: 'Seychelles',
    dialCode: '+248',
    flag: '🇸🇨',
    format: 'X XX XX XX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'SD',
    name: 'Sudan',
    dialCode: '+249',
    flag: '🇸🇩',
    format: 'XX XXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'SE',
    name: 'Sweden',
    dialCode: '+46',
    flag: '🇸🇪',
    format: 'XX XXX XX XX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'SG',
    name: 'Singapore',
    dialCode: '+65',
    flag: '🇸🇬',
    format: 'XXXX XXXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'SH',
    name: 'Saint Helena',
    dialCode: '+290',
    flag: '🇸🇭',
    format: 'XXXX',
    minLength: 4,
    maxLength: 4,
  },
  {
    code: 'SI',
    name: 'Slovenia',
    dialCode: '+386',
    flag: '🇸🇮',
    format: 'XX XXX XXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'SJ',
    name: 'Svalbard and Jan Mayen',
    dialCode: '+47',
    flag: '🇸🇯',
    format: 'XXX XX XXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'SK',
    name: 'Slovakia',
    dialCode: '+421',
    flag: '🇸🇰',
    format: 'XXX XXX XXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'SL',
    name: 'Sierra Leone',
    dialCode: '+232',
    flag: '🇸🇱',
    format: 'XX XXX XXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'SM',
    name: 'San Marino',
    dialCode: '+378',
    flag: '🇸🇲',
    format: 'XXXX XXXXXX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'SN',
    name: 'Senegal',
    dialCode: '+221',
    flag: '🇸🇳',
    format: 'XX XXX XX XX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'SO',
    name: 'Somalia',
    dialCode: '+252',
    flag: '🇸🇴',
    format: 'XX XXX XXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'SR',
    name: 'Suriname',
    dialCode: '+597',
    flag: '🇸🇷',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'SS',
    name: 'South Sudan',
    dialCode: '+211',
    flag: '🇸🇸',
    format: 'XX XXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'ST',
    name: 'São Tomé and Príncipe',
    dialCode: '+239',
    flag: '🇸🇹',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'SV',
    name: 'El Salvador',
    dialCode: '+503',
    flag: '🇸🇻',
    format: 'XXXX XXXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'SX',
    name: 'Sint Maarten',
    dialCode: '+1721',
    flag: '🇸🇽',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'SY',
    name: 'Syria',
    dialCode: '+963',
    flag: '🇸🇾',
    format: 'XXX XXX XXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'SZ',
    name: 'Eswatini',
    dialCode: '+268',
    flag: '🇸🇿',
    format: 'XXXX XXXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'TC',
    name: 'Turks and Caicos Islands',
    dialCode: '+1649',
    flag: '🇹🇨',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'TD',
    name: 'Chad',
    dialCode: '+235',
    flag: '🇹🇩',
    format: 'XX XX XX XX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'TF',
    name: 'French Southern and Antarctic Lands',
    dialCode: '+262',
    flag: '🇹🇫',
    format: 'XXX XX XX XX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'TG',
    name: 'Togo',
    dialCode: '+228',
    flag: '🇹🇬',
    format: 'XX XXX XXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'TH',
    name: 'Thailand',
    dialCode: '+66',
    flag: '🇹🇭',
    format: 'XX XXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'TJ',
    name: 'Tajikistan',
    dialCode: '+992',
    flag: '🇹🇯',
    format: 'XXX XXX XXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'TK',
    name: 'Tokelau',
    dialCode: '+690',
    flag: '🇹🇰',
    format: 'XXXX',
    minLength: 4,
    maxLength: 4,
  },
  {
    code: 'TL',
    name: 'Timor-Leste',
    dialCode: '+670',
    flag: '🇹🇱',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'TM',
    name: 'Turkmenistan',
    dialCode: '+993',
    flag: '🇹🇲',
    format: 'XX XXX XXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'TN',
    name: 'Tunisia',
    dialCode: '+216',
    flag: '🇹🇳',
    format: 'XX XXX XXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'TO',
    name: 'Tonga',
    dialCode: '+676',
    flag: '🇹🇴',
    format: 'XXXXX',
    minLength: 5,
    maxLength: 5,
  },
  {
    code: 'TR',
    name: 'Turkey',
    dialCode: '+90',
    flag: '🇹🇷',
    format: 'XXX XXX XX XX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'TT',
    name: 'Trinidad and Tobago',
    dialCode: '+1868',
    flag: '🇹🇹',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'TV',
    name: 'Tuvalu',
    dialCode: '+688',
    flag: '🇹🇻',
    format: 'XXXXX',
    minLength: 5,
    maxLength: 5,
  },
  {
    code: 'TW',
    name: 'Taiwan',
    dialCode: '+886',
    flag: '🇹🇼',
    format: 'XXX XXX XXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'TZ',
    name: 'Tanzania',
    dialCode: '+255',
    flag: '🇹🇿',
    format: 'XXX XXX XXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'UA',
    name: 'Ukraine',
    dialCode: '+380',
    flag: '🇺🇦',
    format: 'XX XXX XX XX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'UG',
    name: 'Uganda',
    dialCode: '+256',
    flag: '🇺🇬',
    format: 'XXX XXX XXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'US',
    name: 'United States',
    dialCode: '+1',
    flag: '🇺🇸',
    format: 'XXX XXX XXXX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'UY',
    name: 'Uruguay',
    dialCode: '+598',
    flag: '🇺🇾',
    format: 'XXXX XXXX',
    minLength: 8,
    maxLength: 8,
  },
  {
    code: 'UZ',
    name: 'Uzbekistan',
    dialCode: '+998',
    flag: '🇺🇿',
    format: 'XX XXX XX XX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'VA',
    name: 'Vatican City',
    dialCode: '+39',
    flag: '🇻🇦',
    format: 'XXX XXX XXXX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'VC',
    name: 'Saint Vincent and the Grenadines',
    dialCode: '+1784',
    flag: '🇻🇨',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'VE',
    name: 'Venezuela',
    dialCode: '+58',
    flag: '🇻🇪',
    format: 'XXX XXX XXXX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'VG',
    name: 'British Virgin Islands',
    dialCode: '+1284',
    flag: '🇻🇬',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'VI',
    name: 'United States Virgin Islands',
    dialCode: '+1340',
    flag: '🇻🇮',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'VN',
    name: 'Vietnam',
    dialCode: '+84',
    flag: '🇻🇳',
    format: 'XXX XXX XXXX',
    minLength: 10,
    maxLength: 10,
  },
  {
    code: 'VU',
    name: 'Vanuatu',
    dialCode: '+678',
    flag: '🇻🇺',
    format: 'XXX XXXX',
    minLength: 7,
    maxLength: 7,
  },
  {
    code: 'WF',
    name: 'Wallis and Futuna',
    dialCode: '+681',
    flag: '🇼🇫',
    format: 'XX XX XX',
    minLength: 6,
    maxLength: 6,
  },
  {
    code: 'WS',
    name: 'Samoa',
    dialCode: '+685',
    flag: '🇼🇸',
    format: 'XX XXXX',
    minLength: 6,
    maxLength: 6,
  },
  {
    code: 'YE',
    name: 'Yemen',
    dialCode: '+967',
    flag: '🇾🇪',
    format: 'XXX XXX XXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'YT',
    name: 'Mayotte',
    dialCode: '+262',
    flag: '🇾🇹',
    format: 'XXX XX XX XX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'ZA',
    name: 'South Africa',
    dialCode: '+27',
    flag: '🇿🇦',
    format: 'XX XXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'ZM',
    name: 'Zambia',
    dialCode: '+260',
    flag: '🇿🇲',
    format: 'XX XXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
  {
    code: 'ZW',
    name: 'Zimbabwe',
    dialCode: '+263',
    flag: '🇿🇼',
    format: 'XX XXX XXXX',
    minLength: 9,
    maxLength: 9,
  },
];

// Helper function to find country by dial code
export const findCountryByDialCode = (dialCode: string): Country | undefined => {
  return countries.find(country => country.dialCode === dialCode);
};

// Helper function to find country by country code
export const findCountryByCode = (code: string): Country | undefined => {
  return countries.find(country => country.code === code);
};

// Helper function to get default country (Iceland)
export const getDefaultCountry = (): Country => {
  return findCountryByCode('IS') || countries[0];
};
